import { ADDNEW, REMOVE } from './actionTypes';

const initialState = [];

const counterReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADDNEW:
      return [...state, action.payload];

    case REMOVE:
      return state.filter((_, idx) => idx !== action.payload);

    default:
      return state;
  }
};

export default counterReducer;
